<!-- 评价管理 -->
<template>
  <div class="container">
    <header class="header">
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="评价列表" name="1">
          <evaluateList></evaluateList>
        </el-tab-pane>
        <el-tab-pane label="投诉列表" name="2">
          <complaintList></complaintList>
        </el-tab-pane>
        <el-tab-pane label="回复模版设置" name="3">
          <replyTele></replyTele>
        </el-tab-pane>
      </el-tabs>
    </header>
  </div>
</template>

<script>
import evaluateList from "./child/evaluateList.vue";
import complaintList from "./child/complaintList.vue";
import replyTele from "./child/replyTele.vue";
export default {
  components: {
    evaluateList,
    complaintList,
    replyTele,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__nav-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
}
.container {
  background-color: #fff;
  padding: 0.1rem;
  .header {
    display: flex;
    justify-content: center;
  }
}
</style>
